import { useLanguage } from "../contexts/LanguageContext";
import CustomerLayout from "../components/CustomerLayout";
import { Zap, TrendingUp } from "lucide-react";

const SEOServices = () => {
  const { language } = useLanguage();

  return (
    <CustomerLayout activeId="seo">
      <div className="w-full max-w-3xl mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-10">
        <div className="mb-10 text-center">
          <h1 className="text-2xl md:text-4xl font-mono font-bold tracking-tight uppercase mb-3 flex items-center justify-center gap-3">
            <TrendingUp className="w-7 h-7 text-primary flex-shrink-0" />
            SEO <span className="gradient-text">{language === "tr" ? "HİZMETLERİ" : "SERVICES"}</span>
          </h1>
          <p className="text-muted-foreground font-mono text-sm max-w-xl mx-auto">
            {language === "tr"
              ? "Gelişmiş SEO araçları ile sitenizin performansını artırın"
              : "Boost your site's performance with advanced SEO tools"}
          </p>
        </div>

        <div className="glass border-yellow-500/50 bg-yellow-500/5 p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-yellow-500/20 flex items-center justify-center">
            <Zap className="w-10 h-10 text-yellow-400" />
          </div>
          <h2 className="text-2xl font-mono font-bold text-yellow-400 mb-4">
            {language === "tr" ? "GEÇİCİ OLARAK DEVRE DIŞI" : "TEMPORARILY DISABLED"}
          </h2>
          <p className="text-muted-foreground font-mono text-sm mb-4 max-w-lg mx-auto">
            {language === "tr"
              ? "SEO hizmetleri bakım ve geliştirme nedeniyle geçici olarak kapalıdır. Kısa süre içinde tekrar aktif olacaktır."
              : "SEO services are temporarily closed for maintenance and development. They will be back online soon."}
          </p>
          <p className="text-sm text-muted-foreground font-mono">
            {language === "tr" ? "Anlayışınız için teşekkür ederiz." : "Thank you for your understanding."}
          </p>
        </div>
      </div>
    </CustomerLayout>
  );
};

export default SEOServices;
